/* eslint-disable react-hooks/rules-of-hooks */
import {
  CustomButton,
  CustomCheckbox,
  CustomCollapseCard,
  CustomForm,
  CustomFormItem,
  CustomImage,
  CustomInput,
  CustomMoneyInput,
  CustomNumberInput,
  errorDialog,
  Text,
  useText,
} from '@src/components';
import '@src/styles/cardOrder/cardDetailInformation.scss';
import '@src/styles/balanceUpload/cardListInformation.scss';
import { Collapse, Form, Tooltip, Menu, Dropdown } from 'antd';
import { isGreaterMaximumLoadedAmount, moneyFormat, turkishToLower } from '@src/utils/utils';
import iconSearchWhite from '@src/assets/icons/icon-white-search.svg';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createPortal } from 'react-dom';
import {
  loadBalanceDetailPriceUpdate,
  removeExcelUploadErrorMessages,
  setBalanceUploadDetails,
  setSelectedBalanceUploadDetails,
} from '@src/store/slice/balanceUploadDetailSlice';
import { addressGetList } from '@src/store/slice/addressSlice';
import {
  setIsAllSelectedRowKeys,
  setRunTimeTotalPrice,
  setSelectedRowKeys,
} from '@src/store/slice/balanceUploadSlice';
import { setLoadingState } from '@src/store/slice/appSettingsSlice';
import xlsx from '@src/utils/xlsx';
import { VirtualizedAndLazyScrollTable } from '@src/components/VirtualizedAndLazyScrollTable';
import ExcelUploadRowDeletedModal from '@src/pages/ticketRestaurant/balanceUpload/balanceInformation/ExcelUploadRowDeleteModal';
import '@src/styles/balanceUpload/excelUploadTable.scss';
import iconTCard from '@src/assets/icons/icon-t-card.svg';
import iconExcel from '@src/assets/icons/icon_excel.png';
import iconDelete from '@src/assets/icons/icon_garbage.svg';
import iconDikkat from '@src/assets/icons/icon-dikkat.svg';
import { debounce } from 'lodash/function';
import PropTypes from 'prop-types';
import filterButton from '@src/assets/icons/icn-down-white.svg';
import icnUp from '@src/assets/icons/icn_up.png';
import icnDown from '@src/assets/icons/icn_down.png';
import CustomMultiSelect from '@src/components/CustomMultiSelect';
import CustomPagination from '@src/components/CustomPagination';
import iconChevronDown from '@src/assets/icons/chevron-down.svg';

const { Panel } = Collapse;

const RefNumberCell = ({
  ExcelTableList,
  text,
  record,
  excelUploadErrorMessages,
  decodedExcelFile,
  excelUploadPrimaryColumnObject,
  setCounter,
  allCard,
  dispatch,
  excelParams,
}) => {
  const hasError = excelUploadErrorMessages?.find(
    (e) => e?.column === 'RefNo' && e?.rowNumber === record?.rowNumber,
  );
  const hasErrorCardNumber = excelUploadErrorMessages?.find(
    (e) => e?.column === 'CardNumber' && e?.rowNumber === record?.rowNumber,
  );
  const referenceNumberPlaceholder = useText('referenceNumber');
  const maximumLoadingLimitPerCardIs = useText('maximumLoadingLimitPerCardIs');
  const [isEditable, setIsEditable] = useState(false);
  if (!hasError) {
    return text;
  }
  if (isEditable) {
    return (
      <div
        style={{ border: '1px solid #df2747', backgroundColor: '#f2f5f7' }}
        onMouseLeave={async () => {
          setIsEditable(false);
          if (
            ExcelTableList.filter((b) => record?.refNo !== '' && record?.refNo === b.refNo)
              .length === 1 &&
            allCard.withRefNo.get(record?.refNo)
          ) {
            await dispatch(removeExcelUploadErrorMessages(hasError));
            await dispatch(removeExcelUploadErrorMessages(hasErrorCardNumber));
            const zeroError = excelUploadErrorMessages?.find(
              (e) => e?.column === 'RefNo' && e?.rowNumber === 0,
            );
            const zeroErrorOther = excelUploadErrorMessages?.find(
              (e) => e?.column === 'CardNumber' && e?.rowNumber === 0,
            );
            await dispatch(removeExcelUploadErrorMessages(zeroError));
            await dispatch(removeExcelUploadErrorMessages(zeroErrorOther));
            setCounter((counter) => counter + 1);
          }
        }}
      >
        <CustomInput
          id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-refNumber-input"
          initialValue={text}
          onMouseLeave={async (e) => {
            const row = decodedExcelFile.current?.find((r) => r.rowNumber === record?.rowNumber);
            const value = e.target.value;
            if (excelParams.current.UseDefaultTemplate) {
              row['E'] = value;
            } else if (excelUploadPrimaryColumnObject.type === 'refNo') {
              row[excelUploadPrimaryColumnObject.column] = value;
            }
            record.refNo = value;
            setCounter((counter) => counter + 1);
          }}
          placeholder={referenceNumberPlaceholder}
          height={36}
        />
      </div>
    );
  }

  if (hasError) {
    return (
      <Tooltip
        placement="bottomRight"
        overlayClassName="custom-tooltip-excel-upload"
        title={
          <div>
            <CustomImage src={iconDikkat} />
            {hasError?.errorMessage}
          </div>
        }
      >
        <div
          onClick={() => setIsEditable(true)}
          style={{
            border: '1px solid #df2747',
            backgroundColor: 'rgba(239, 124, 120, 0.15)',
            padding: '8px',
          }}
        >
          &nbsp;{text}
        </div>
      </Tooltip>
    );
  }
  return text;
};

RefNumberCell.propTypes = {
  ExcelTableList: PropTypes.any,
  text: PropTypes.any,
  excelUploadErrorMessages: PropTypes.any,
  decodedExcelFile: PropTypes.any,
  excelUploadPrimaryColumnObject: PropTypes.any,
  setCounter: PropTypes.any,
  allCard: PropTypes.any,
  dispatch: PropTypes.any,
  excelParams: PropTypes.any,
  record: PropTypes.any,
};

const CardNumberCell = ({
  ExcelTableList,
  text,
  record,
  excelUploadErrorMessages,
  decodedExcelFile,
  excelUploadPrimaryColumnObject,
  setCounter,
  allCard,
  dispatch,
}) => {
  const hasError = excelUploadErrorMessages?.find(
    (e) => e?.column === 'CardNumber' && e?.rowNumber === record?.rowNumber,
  );
  const hasErrorRefNo = excelUploadErrorMessages?.find(
    (e) => e?.column === 'RefNo' && e?.rowNumber === record?.rowNumber,
  );
  const cardNumberPlaceholder = useText('cardNumber2');
  const [isEditable, setIsEditable] = useState(false);
  if (!hasError) {
    return text;
  }
  if (isEditable) {
    return (
      <div
        style={{
          border: '1px solid #df2747',
          backgroundColor: 'rgba(239, 124, 120, 0.15)',
        }}
        onMouseLeave={async () => {
          setIsEditable(false);
          if (
            ExcelTableList.filter(
              (b) => record?.cardNumber !== '' && record?.cardNumber === b.cardNumber,
            ).length === 1 &&
            allCard.withCardNo.get(record.cardNumber)
          ) {
            await dispatch(removeExcelUploadErrorMessages(hasError));
            await dispatch(removeExcelUploadErrorMessages(hasErrorRefNo));
            const zeroError = excelUploadErrorMessages?.find(
              (e) => e?.column === 'CardNumber' && e?.rowNumber === 0,
            );
            const otherZeroError = excelUploadErrorMessages?.find(
              (e) => e?.column === 'RefNo' && e?.rowNumber === 0,
            );
            await dispatch(removeExcelUploadErrorMessages(zeroError));
            await dispatch(removeExcelUploadErrorMessages(otherZeroError));
          }
        }}
      >
        <CustomInput
          id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-cardNumber-input"
          value={text}
          onInput={async (e) => {
            const row = decodedExcelFile.current[record?.id];
            row[excelUploadPrimaryColumnObject.column] = e.target.value;
            setCounter((counter) => counter + 1);
            record.cardNumber = e.target.value;
          }}
          placeholder={cardNumberPlaceholder}
          height={36}
        />
      </div>
    );
  }
  if (hasError) {
    return (
      <Tooltip
        placement="bottomRight"
        overlayClassName="custom-tooltip-excel-upload"
        title={
          <div>
            <CustomImage src={iconDikkat} />
            {hasError.errorMessage}
          </div>
        }
      >
        <div
          onClick={() => setIsEditable(true)}
          style={{
            border: '1px solid #df2747',
            backgroundColor: 'rgba(239, 124, 120, 0.15)',
            padding: '8px',
          }}
        >
          &nbsp;{text}
        </div>
      </Tooltip>
    );
  }
  return text;
};
CardNumberCell.propTypes = {
  ExcelTableList: PropTypes.any,
  text: PropTypes.any,
  excelUploadErrorMessages: PropTypes.any,
  decodedExcelFile: PropTypes.any,
  excelUploadPrimaryColumnObject: PropTypes.any,
  setCounter: PropTypes.any,
  allCard: PropTypes.any,
  dispatch: PropTypes.any,
  record: PropTypes.any,
};

const PriceCell = ({
  text,
  record,
  addUpdatePrice,
  excelUploadErrorMessages,
  dispatch,
  isCompliments = false,
}) => {
  const hasError = excelUploadErrorMessages?.find(
    (e) => e?.column === 'Price' && e?.rowNumber === record?.rowNumber,
  );
  const hasCardNumberError = excelUploadErrorMessages?.find(
    (e) => e?.column === 'CardNumber' && e?.rowNumber === record?.rowNumber,
  );
  const amountPlaceholder = useText('amount3');
  const [isEditable, setIsEditable] = useState(false);
  if (!isEditable && hasError) {
    if (hasError?.errorMessage === '') {
      return (
        <div
          onClick={() => {
            if (!hasCardNumberError) {
              setIsEditable(true);
            }
          }}
          style={{
            border: '1px solid #df2747',
            backgroundColor: 'rgba(239, 124, 120, 0.15)',
            padding: '8px',
          }}
        >
          0
        </div>
      );
    }
    return (
      <Tooltip
        onClick={async () => {
          setIsEditable(true);
        }}
        placement="bottomRight"
        overlayClassName="custom-tooltip-excel-upload"
        title={
          <div>
            <CustomImage src={iconDikkat} />
            {hasError?.errorMessage}
          </div>
        }
      >
        <div
          style={{
            border: '1px solid #df2747',
            backgroundColor: 'rgba(239, 124, 120, 0.15)',
            padding: '8px',
            borderRadius: '4px',
          }}
        >
          0
        </div>
      </Tooltip>
    );
  }
  const updatePrice = async (...args) => {
    await addUpdatePrice(...args);
    const zeroError = excelUploadErrorMessages?.find(
      (e) => e?.column === 'Price' && e?.rowNumber === 0,
    );
    await dispatch(removeExcelUploadErrorMessages(zeroError));
  };

  if (hasError) {
    dispatch(removeExcelUploadErrorMessages(hasError));
  }
  const updateWithDebounce = debounce(async (value, record) => {
    await addUpdatePrice(value, record, true);
  }, 2000);

  return (
    <CustomMoneyInput
      id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-price-moneyInput"
      value={text}
      placeholder={amountPlaceholder}
      height={36}
      onBlur={async (e) => {
        await updatePrice(e.target.value, record);
      }}
      addUpdatePrice={async (...args) => {
        await updatePrice(...args);
      }}
      record={record}
      onInput={(e) => {
        updateWithDebounce(e.target.value, record);
      }}
      className={isCompliments ? 'comp-input-right-align' : ''}
    />
  );
};

PriceCell.propTypes = {
  text: PropTypes.any,
  record: PropTypes.any,
  excelUploadErrorMessages: PropTypes.any,
  dispatch: PropTypes.any,
  isCompliments: PropTypes.any,
  addUpdatePrice: PropTypes.any,
};

function getExcelDataWithDefaultTemplate({
  excelUploadPrimaryColumnObject,
  excelRow,
  allCard,
  rawData,
}) {
  if (excelUploadPrimaryColumnObject.type === 'refNo') {
    excelRow = allCard.withRefNo.get(rawData['E']);
    if (!rawData.hasOwnProperty('E')) {
      excelRow = allCard.withCardNo.get(rawData['B']);
    }
  } else {
    excelRow = allCard.withCardNo.get(rawData['B']);
    if (!rawData.hasOwnProperty('B')) {
      excelRow = allCard.withRefNo.get(rawData['E']);
    }
  }
  return excelRow;
}

function getExcelData(
  excelParams,
  allCard,
  rawData,
  balanceUploadDetails,
  cardNumber,
  refNo,
  excelUploadPrimaryColumnObject,
) {
  let excelRow = null;
  let price = 0;
  const cardNumberTrim = cardNumber ? cardNumber.toString().trim() : '';
  const refNoTrim = refNo ? refNo.toString().trim() : '';
  if (excelParams.current.UseDefaultTemplate) {
    excelRow = getExcelDataWithDefaultTemplate({
      excelUploadPrimaryColumnObject,
      excelRow,
      allCard,
      rawData,
    });
    price =
      balanceUploadDetails?.find((row) => row.cardNumber === excelRow?.cardNumber)?.price || 0;
  } else {
    if (cardNumberTrim) {
      excelRow = allCard.withCardNo?.get(`${cardNumberTrim}`);
    } else if (refNoTrim) {
      excelRow = allCard.withRefNo?.get(`${refNoTrim}`);
    }
    const isRefNoExcel = excelUploadPrimaryColumnObject.type === 'refNo';
    price =
      balanceUploadDetails?.find((row) =>
        isRefNoExcel ? row.refNo === `${refNoTrim}` : row.cardNumber === cardNumberTrim,
      )?.price || 0;
  }
  if (!excelRow) {
    excelRow = balanceUploadDetails?.find(
      (row) =>
        (cardNumberTrim && row.cardNumber === cardNumberTrim) ||
        (refNoTrim && row.refNo === `${refNoTrim}`),
    );
    price = excelRow?.price || 0;
  }
  return { excelRow, price };
}

function mapBalanceUploadWithExcelData({
  excelParams,
  rawData,
  allCard,
  excelUploadPrimaryColumnObject,
  index,
  balanceUploadDetails,
  cardNumber,
  refNo,
  rowNumber,
}) {
  if (excelUploadPrimaryColumnObject.FirstRowHeaderColumn && index === 0) return;
  const { excelRow, price } = getExcelData(
    excelParams,
    allCard,
    rawData,
    balanceUploadDetails,
    cardNumber,
    refNo,
    excelUploadPrimaryColumnObject,
  );
  return {
    id: index,
    rowNumber: rowNumber,
    name: excelRow?.name || (excelParams.current.UseDefaultTemplate ? rawData?.C : '') || '',
    surname:
      excelRow?.surname || (excelParams.current.UseDefaultTemplate ? rawData?.D : '') || '',
    refNo: excelRow?.refNo || refNo || (excelParams.current.UseDefaultTemplate ? rawData?.E : '') || '',
    cardNumber:
      excelRow?.cardNumber ||
      cardNumber ||
      (excelParams.current.UseDefaultTemplate ? rawData?.B : '') ||
      '',
    price: price,
  };
}

const ExcelUploadTable = ({
  decodedExcelFile,
  excelParams,
  isCompliments = false,
  isMarket = false,
}) => {
  const [form] = Form.useForm();
  const [isBtnActive, setIsBtnActive] = useState(false);
  const [counter, setCounter] = useState(0);
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(0);
  const FilterRef = useRef({});
  const { currentLoadBalance, selectedRowKeys, isAllSelectedRowKeys } = useSelector(
    (state) => state?.balanceUpload,
  );
  const { addressList } = useSelector((state) => state?.address);
  const {
    balanceUploadDetails,
    excelUploadPrimaryColumnObject,
    excelUploadErrorMessages,
    excelUploadErrorMessagesFreeze,
    allBalanceUploadCards,
  } = useSelector((state) => state?.balanceUploadDetail);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { maximumLoadedAmount } = useSelector((state) => state?.orderLimits);
  const [isGetAddresses, setIsGetAddresses] = useState(false);
  const dispatch = useDispatch();

  const { addressListByUserQuery } = useSelector((state) => state?.address);
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedAddressListReset, setSelectedAddressListReset] = useState(false);
  const [showCount, setShowCount] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);

  const cardInformation2 = useText('cardInformation2');
  const maximumLoadingLimitPerCardIs = useText('maximumLoadingLimitPerCardIs');

  useEffect(() => {
    (async () => {
      if (addressList.length === 0 && !isGetAddresses) {
        setIsGetAddresses(true);
        dispatch(addressGetList());
      }
    })();
  }, [addressList, dispatch, isGetAddresses]);
  const clickAddressListMultiSelectChange = async (values) => {
    form.setFieldsValue({ addressIdList: values.map((item) => ({ addressId: item.value })) });
    setSelectedAddressListReset(false);
    setTimeout(async () => {
      await onValuesChange();
    }, 200);
  };

  useEffect(() => {
    setShowDeleteButton(selectedRowKeys.length > 0);
  }, [selectedRowKeys]);

  const allCard = useMemo(() => {
    const withRefNo = new Map(allBalanceUploadCards?.map((item) => [item?.refNo, item]));
    const withCardNo = new Map(allBalanceUploadCards?.map((item) => [item?.cardNumber, item]));
    return {
      withRefNo,
      withCardNo,
    };
  }, [allBalanceUploadCards]);

  useEffect(async () => {
    if (isAllSelectedRowKeys) {
      await dispatch(setSelectedRowKeys([...allCard.withCardNo.keys()]));
    }
  }, [allBalanceUploadCards]);

  const ExcelTableListFunc = () => {
    const primaryKeys = getPrimaryKeys();
    const filteredKeys = filterKeys(primaryKeys);
    const sortedFilteredKeys = sortKeys(filteredKeys);
    return sortedFilteredKeys;
  };

  const getPrimaryKeys = () => {
    return decodedExcelFile?.current?.map((excelRow) => ({
      rowNumber: excelRow?.rowNumber,
      [excelUploadPrimaryColumnObject.type === 'refNo' ? 'refNo' : 'cardNumber']:
        excelRow[excelUploadPrimaryColumnObject.column],
      rawData: excelRow,
    }));
  };

  const filterKeys = (keys) => {
    return keys
      ?.map(({ cardNumber, rowNumber, refNo, rawData }, index) =>
        mapBalanceUploadWithExcelData({
          excelParams,
          rawData,
          allCard,
          excelUploadPrimaryColumnObject,
          index,
          balanceUploadDetails,
          cardNumber,
          refNo,
          rowNumber,
        }),
      )
      .filter(Boolean)
      .filter((item) => {
        return applyFilters(item);
      });
  };

  const applyFilters = (item) => {
    const shouldShowOnlyPriced = FilterRef?.current?.showOnlyPriced;
    if (shouldShowOnlyPriced && item.price === 0) {
      return false;
    }
    return !(
      (FilterRef.current?.rowNumber &&
        item?.rowNumber !== parseInt(FilterRef.current?.rowNumber)) ||
      (FilterRef.current?.referenceNumber && item?.refNo !== FilterRef.current?.referenceNumber) ||
      (FilterRef.current?.name &&
        !turkishToLower(`${item?.name}`).includes(turkishToLower(`${FilterRef.current?.name}`))) ||
      (FilterRef.current?.surname &&
        !turkishToLower(`${item?.surname}`).includes(
          turkishToLower(`${FilterRef.current?.surname}`),
        )) ||
      (FilterRef.current?.cardNumber &&
        !`${item?.cardNumber}`.includes(`${FilterRef.current?.cardNumber}`)) ||
      (FilterRef.current?.refNo && !`${item?.refNo}`.includes(`${FilterRef.current?.refNo}`)) ||
      (FilterRef.current?.price && parseInt(item?.price) !== parseInt(FilterRef.current?.price))
    );
  };

  const sortKeys = (keys) => {
    return keys?.sort((a, b) =>
      excelUploadErrorMessagesFreeze?.find((e) => e?.rowNumber === a?.rowNumber) ? -1 : 1,
    );
  };

  const ExcelTableList = useMemo(
    () => ExcelTableListFunc(),
    [
      counter,
      balanceUploadDetails,
      excelUploadErrorMessages,
      excelUploadErrorMessagesFreeze,
      isAllSelectedRowKeys,
    ],
  );
  const totalPrice = useMemo(() => {
    return ExcelTableList?.reduce((acc, item) => {
      const hasError = excelUploadErrorMessages?.find((e) => e?.rowNumber === item?.rowNumber);
      return hasError ? acc : acc + (item?.price || 0);
    }, 0);
  }, [ExcelTableList, excelUploadErrorMessages]);

  useEffect(() => {
    dispatch(setRunTimeTotalPrice(totalPrice));
  }, [totalPrice, dispatch]);

  const totalOrderCount = ExcelTableList?.filter((item) => item.price !== 0).length;

  const downloadLiveExcel = async () => {
    let newTable = ExcelTableList.sort((a, b) => a.rowNumber - b.rowNumber);
    if (newTable.length === 0) return;
    const [minRowL, maxRowL] = [newTable[0]?.rowNumber, newTable[newTable.length - 1]?.rowNumber];
    for (let i = minRowL; i <= maxRowL; i++) {
      const row = newTable.find((r) => r.rowNumber === i);
      if (!row) {
        newTable.push({
          rowNumber: i,
          name: ' ',
          surname: ' ',
          refNo: ' ',
          cardNumber: ' ',
          price: ' ',
        });
      }
    }
    newTable = newTable
      .sort((a, b) => a.rowNumber - b.rowNumber)
      ?.map((item, i) => {
        const addressId = allCard.withCardNo?.get(item?.cardNumber)?.addressId;
        return {
          'Teslimat Adresi':
            addressList?.find((address) => address.id === addressId)?.addressName || '',
          'Kart Numarası': item?.cardNumber || '',
          Ad: item?.name || '',
          Soyad: item?.surname || '',
          'Referans Numarası': item?.refNo || '',
          'Aylık Tutar': item?.price || '',
        };
      });
    const ws = xlsx.utils.json_to_sheet(newTable);
    const columns = {
      CardNumber: 'B',
      RefNo: 'E',
      Price: 'F',
    };
    excelUploadErrorMessages.forEach((item) => {
      if (item?.errorMessage === '' || item.rowNumber === 0) return;
      const cell = columns[item?.column] + item?.rowNumber;
      xlsx.utils.cell_add_comment(ws[cell], item?.errorMessage);
    });
    const wb = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(wb, ws, 'TicketOnlineExcelUploadTable');
    xlsx.writeFile(wb, 'TicketOnlineExcelUploadTable.xlsx');
  };
  const addUpdatePrice = async (value, record) => {
    let val = value?.replaceAll('.', '')?.replace(',', '.');
    let v = val === '' ? 0 : parseFloat(val);
    if (record?.price !== v) {
      if (
        isGreaterMaximumLoadedAmount({
          controlValue: maximumLoadedAmount,
          price: val,
        })
      ) {
        errorDialog({
          title: <Text t="error" />,
          message: maximumLoadingLimitPerCardIs.replaceAll('{amount}', maximumLoadedAmount),
        });
        return;
      }

      const data = {
        price: parseFloat(v),
        idList: null,
        LoadBalanceId: currentLoadBalance?.id,
        cardNumber: [record?.cardNumber.toString()],
        dontReFetch: true,
        customerId: selectedCustomer?.customerId,
      };
      let tempBalanceUploadDetails = balanceUploadDetails.map((a) => a);
      const newCardDetail = tempBalanceUploadDetails?.find(
        (item) => item?.cardNumber === record?.cardNumber,
      );
      if (newCardDetail) {
        tempBalanceUploadDetails = tempBalanceUploadDetails?.map((item) => ({
          ...item,
          price: item?.cardNumber === record?.cardNumber ? parseFloat(v) : item?.price,
        }));
      } else {
        tempBalanceUploadDetails?.push({
          ...record,
          rowNumber: record?.sequenceNo,
          price: data.price,
        });
      }
      await dispatch(setBalanceUploadDetails([...tempBalanceUploadDetails]));
      await dispatch(setLoadingState(false));
      await dispatch(loadBalanceDetailPriceUpdate(data));
      await dispatch(setLoadingState(true));
    }
  };

  const submitFilter = async () => {
    FilterRef.current = await form.validateFields();
    setCounter((counter) => counter + 1);
  };

  const clearForm = async () => {
    setIsBtnActive(false);
    form.resetFields();
    FilterRef.current = {};
    setCounter((counter) => counter + 1);
  };

  const onGridSelectChange = (record, data) => {
    dispatch(setSelectedRowKeys(record));
    dispatch(setSelectedBalanceUploadDetails(data));
  };

  const onValuesChange = (changedValues, allValues) => {
    setIsBtnActive(Object.values(allValues).some((value) => value !== undefined && value !== ''));
  };

  const removeErrorMessages = async (rowNumber) => {
    const allError = excelUploadErrorMessages?.filter((e) => e.rowNumber === rowNumber) || [];
    for (const item of allError) {
      await dispatch(removeExcelUploadErrorMessages(item));
    }
  };

  const afterDeleteAction = async (selectedBalanceUploadDetails) => {
    setShowDeleteButton(false);
    for (const selectedBalanceUploadDetail of selectedBalanceUploadDetails) {
      await removeErrorMessages(selectedBalanceUploadDetail?.rowNumber);
      const error = selectedBalanceUploadDetails.filter(
        (b) => b?.cardNumber === selectedBalanceUploadDetail?.cardNumber,
      );
      const allError = decodedExcelFile.current?.filter(
        (excelRow) =>
          selectedBalanceUploadDetail?.cardNumber ===
          excelRow[excelUploadPrimaryColumnObject.column] ||
          selectedBalanceUploadDetail?.refNo === excelRow[excelUploadPrimaryColumnObject.column],
      );
      for (const allErrorElement of allError) {
        const x =
          excelUploadErrorMessages?.filter(
            (e) =>
              e.rowNumber !== selectedBalanceUploadDetail.rowNumber &&
              e.rowNumber === allErrorElement?.rowNumber,
          ) || [];
        if (allError.length - error.length === 1) {
          for (const item of x.filter((e) => e?.group === 'Duplicate')) {
            await dispatch(removeExcelUploadErrorMessages(item));
          }
        }
      }
    }
    selectedBalanceUploadDetails.forEach((item) => {
      decodedExcelFile.current = decodedExcelFile.current.filter(
        (row) => row.rowNumber !== item.rowNumber,
      );
    });
    const deletedCardNumbers = selectedBalanceUploadDetails.map((b) => b?.cardNumber);
    await dispatch(
      setBalanceUploadDetails(
        balanceUploadDetails.filter((b) => !deletedCardNumbers.includes(b?.cardNumber)),
      ),
    );
    await dispatch(setSelectedRowKeys([]));
    await dispatch(setSelectedBalanceUploadDetails([]));
  };

  const renderPrice = (text, record) => {
    return PriceCell({
      text,
      record,
      addUpdatePrice,
      excelUploadErrorMessages,
      dispatch,
      isCompliments,
    });
  };

  const renderCardNumber = (text, record) => {
    return CardNumberCell({
      ExcelTableList,
      text,
      record,
      excelUploadErrorMessages,
      decodedExcelFile,
      excelUploadPrimaryColumnObject,
      setCounter,
      allCard,
      dispatch,
      excelParams,
    });
  };

  const columns = isCompliments
    ? [
      {
        title: <Text t="rowUpperCase" />,
        dataIndex: 'rowNumber',
        key: 'id',
        fixed: 'left',
        width: 70,
      },
      {
        title: <Text t="nameUpperCase" />,
        dataIndex: 'name',
        key: 'name',
        width: 100,
      },
      {
        title: <Text t="surnameUpperCase" />,
        dataIndex: 'surname',
        key: 'surname',
        width: 100,
      },
      {
        title: <Text t="referenceCode3" />,
        dataIndex: 'refNo',
        key: 'refNo',
        width: 100,
        render: (text, record) =>
          RefNumberCell({
            ExcelTableList,
            text,
            record,
            excelUploadErrorMessages,
            decodedExcelFile,
            excelUploadPrimaryColumnObject,
            setCounter,
            allCard,
            dispatch,
            excelParams,
          }),
      },
      {
        title: <Text t="cardNumber4" />,
        dataIndex: 'cardNumber',
        key: 'cardNumber',
        width: 140,
        align: 'center',
        render: (text, record) => renderCardNumber(text, record),
      },
      {
        title: <Text t="amountVatIncludedUpperCase" />,
        dataIndex: 'price',
        key: 'price',
        width: 125,
        align: 'right',
        render: (text, record) => renderPrice(text, record),
      },
    ]
    : [
      {
        title: <Text t="rowNoUpperCase" />,
        dataIndex: 'rowNumber',
        key: 'id',
        fixed: 'left',
        width: 70,
        sorter: excelUploadErrorMessages?.length > 0 ? false : (a, b) => a.id - b.id,
      },
      {
        title: <Text t="nameUpperCase" />,
        dataIndex: 'name',
        key: 'name',
        width: 100,
        sorter:
          excelUploadErrorMessages?.length > 0 ? false : (a, b) => a.name.localeCompare(b.name),
      },
      {
        title: <Text t="surnameUpperCase" />,
        dataIndex: 'surname',
        key: 'surname',
        width: 100,
        sorter:
          excelUploadErrorMessages?.length > 0
            ? false
            : (a, b) => a.surname.localeCompare(b.surname),
      },
      {
        title: <Text t="referenceCode3" />,
        dataIndex: 'refNo',
        key: 'refNo',
        width: 100,
        sorter: excelUploadErrorMessages?.length > 0 ? false : (a, b) => a.refNo - b.refNo,
        render: (text, record) =>
          RefNumberCell({
            ExcelTableList,
            text,
            record,
            excelUploadErrorMessages,
            decodedExcelFile,
            excelUploadPrimaryColumnObject,
            setCounter,
            allCard,
            dispatch,
            excelParams,
          }),
      },
      {
        title: <Text t="cardNumber" />,
        dataIndex: 'cardNumber',
        key: 'cardNumber',
        width: 140,
        sorter:
          excelUploadErrorMessages?.length > 0 ? false : (a, b) => a.cardNumber - b.cardNumber,
        render: (text, record) => renderCardNumber(text, record),
      },
      {
        title: <Text t="totalBalanceToBeLoadedVatIncludedUpperCase" />,
        dataIndex: 'price',
        key: 'price',
        width: 85,
        align: 'right',
        sorter: excelUploadErrorMessages?.length > 0 ? false : (a, b) => a.price - b.price,
        render: (text, record) => renderPrice(text, record),
      },
    ];
  const addressListForFilterMultiSelect = useMemo(
    () =>
      addressListByUserQuery?.map((item) => {
        return {
          label: item.addressName,
          value: item.id,
        };
      }),
    [addressListByUserQuery],
  );

  const handlePaginationChange = async (pageNumber, pageSize) => {
    setCurrentPage(pageNumber);
  };

  const clickMenu = (key) => {
    try {
      setShowCount(parseInt(key?.key.toString(), 10));
    } catch (error) {
      console.error(error);
    }
  };

  const menuDropdown = () => (
    <Menu onClick={(key) => clickMenu(key)} className="custom-dropdown-menu">
      <Menu.Item key="100" className="custom-dropdown-item">
        100
      </Menu.Item>
      <Menu.Item key="200" className="custom-dropdown-item">
        200
      </Menu.Item>
      <Menu.Item key="300" className="custom-dropdown-item">
        300
      </Menu.Item>
      <Menu.Item key="400" className="custom-dropdown-item">
        400
      </Menu.Item>
      <Menu.Item key="500" className="custom-dropdown-item">
        500
      </Menu.Item>
    </Menu>
  );

  const renderDeleteButton = () => {
    return (
      <CustomButton
        id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-delete-btn"
        className={`delete-btn ${isCompliments ? 'comp-delete-btn' : ''}`}
        onClick={async () => {
          setOpenDeleteModal(true);
        }}
      >
        <CustomImage className="icon-filter" src={iconDelete} />
        <Text t="deleteSelectedRecords" />
      </CustomButton>
    );
  };

  const renderDeleteModal = () => {
    return (
      <ExcelUploadRowDeletedModal
        modalVisible={openDeleteModal}
        handleModalVisible={setOpenDeleteModal}
        columns={columns}
        afterDelete={afterDeleteAction}
        decodedExcelFile={decodedExcelFile}
        isCompliments={isCompliments}
      />
    );
  };

  if (isCompliments || isMarket) {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            alignItems: 'center',
            backgroundColor: '#475569',
            paddingLeft: 4,
            paddingRight: 4,
            borderBottomLeftRadius: isExpanded ? 0 : 8,
            borderBottomRightRadius: isExpanded ? 0 : 8,
            width: isExpanded ? '100%' : 200,
          }}
        >
          <button
            style={{
              display: 'flex',
              fontSize: 15,
              color: '#fff',
              textAlign: 'right',
              backgroundColor: 'transparent',
              padding: 10,
              width: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 20,
              borderWidth: 0,
              textDecoration: 'underline',
            }}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <CustomImage style={{ width: 24 }} src={filterButton} />
            <Text t="addFilter" />
            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
              <CustomImage style={{ width: 24 }} src={isExpanded ? icnUp : icnDown} />
            </div>
          </button>
        </div>
        {isExpanded && (
          <div className="compliments-filter-card-list">
            <Collapse
              defaultActiveKey={['1']}
              className="filter-collapse-card"
              ghost
              expandIconPosition="right"
            >
              <div>
                <CustomForm
                  name="filterForm"
                  className="compliments-filter-form"
                  initialValues={{
                    showOnlyPriced: false,
                  }}
                  onValuesChange={onValuesChange}
                  autoComplete="off"
                  layout={'horizontal'}
                  form={form}
                  id="loadBalanceFilterForm"
                >
                  <div className="form-item">
                    <CustomFormItem name="name">
                      <CustomInput
                        className="c-form-item"
                        id="comp-balanceUpload-balanceInformation-cardListInformation-name-input"
                        placeholder={useText('name')}
                        height={36}
                      />
                    </CustomFormItem>
                    <CustomFormItem name="surname" className="surname-form-item">
                      <CustomInput
                        className="c-form-item"
                        id="comp-balanceUpload-balanceInformation-cardListInformation-surname-input"
                        placeholder={useText('surname')}
                        height={36}
                      />
                    </CustomFormItem>

                    <CustomFormItem name="cardNumber" className="card-number-form-item">
                      <CustomNumberInput
                        className="c-form-item"
                        id="comp-balanceUpload-balanceInformation-cardListInformation-cardNumber-numberInput"
                        autoComplete="off"
                        placeholder={useText('cardNumber2')}
                        height={36}
                      />
                    </CustomFormItem>

                    <CustomFormItem name="referenceNumber" className="reference-code-form-item">
                      <CustomInput
                        className="c-form-item"
                        id="comp-balanceUpload-balanceInformation-cardListInformation-refNo-input"
                        autoComplete="off"
                        placeholder={useText('referenceCode2')}
                        height={36}
                      />
                    </CustomFormItem>
                    <CustomFormItem
                      name="addressIdList"
                      style={{ display: 'none' }}
                    ></CustomFormItem>
                    <CustomMultiSelect
                      source={addressListForFilterMultiSelect}
                      reset={selectedAddressListReset}
                      onCustomMultiSelectChange={clickAddressListMultiSelectChange}
                      selectSomeItems={useText('deliveryAddress2')}
                      className="c-form-item"
                    />
                    <div
                      className="form-footer"
                      style={{ justifyContent: 'flex-end', alignItems: 'center' }}
                    >
                      <CustomFormItem
                        label={false}
                        name="showOnlyPriced"
                        className="footer-form-item"
                        valuePropName="checked"
                      >
                        <CustomCheckbox
                          id="comp-balanceUpload-balanceInformation-cardListInformation-showOnlyPriced-checkbox"
                          className="only-amount-check"
                          style={{ marginTop: 14, marginRight: 20 }}
                        >
                          <Text t="showThoseWithAmountEntered" />
                        </CustomCheckbox>
                      </CustomFormItem>
                      <div className="action-buttons">
                        <CustomButton
                          id="comp-balanceUpload-balanceInformation-cardListInformation-clear-btn"
                          className="clear-btn"
                          onClick={clearForm}
                        >
                          <Text t="clean" />
                        </CustomButton>
                        <CustomButton
                          id="comp-balanceUpload-balanceInformation-cardListInformation-search-btn"
                          disabled={!isBtnActive}
                          className="search-btn"
                          onClick={submitFilter}
                          style={{ backgroundColor: '#334155' }}
                        >
                          <CustomImage className="icon-search" src={iconSearchWhite} />{' '}
                          <Text t="search" />
                        </CustomButton>
                      </div>
                    </div>
                  </div>
                </CustomForm>
              </div>
            </Collapse>
          </div>
        )}
        <div style={{ display: 'flex', height: 20 }} />

        {showDeleteButton && (
          <div
            className="delete-button-container"
            style={{ backgroundColor: '#f5eaeb', borderRadius: 8, marginBottom: 20 }}
          >
            <span className={'selected-text'}>
              <b>{selectedRowKeys.length}</b> <Text t="recordsSelected" />
            </span>
            {renderDeleteButton()}
          </div>
        )}

        {ExcelTableList?.length > 0 && (
          <VirtualizedAndLazyScrollTable
            rowSelection={{
              preserveSelectedRowKeys: true,
              type: 'checkbox',
              selectedRowKeys,
              onChange: onGridSelectChange,
              onSelectAll: async (selected) => {
                await dispatch(setIsAllSelectedRowKeys(selected));
              },
            }}
            pagination={false}
            dataSource={ExcelTableList?.slice(
              (currentPage - 1) * showCount,
              currentPage * showCount,
            )}
            getDataFunc={() => { }}
            columnsData={columns}
            rowKey={(record) => `balance-upload-${record?.rowNumber}`}
          />
        )}

        {ExcelTableList?.length > 100 && (
          <div
            className="compliment-person-information-table-footer"
            style={{
              backgroundColor: '#fff',
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
            }}
          >
            <div className="d-flex">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  position: 'absolute',
                  left: 20,
                  top: 30,
                  alignItems: 'center',
                }}
              >
                <span className="compliment-more-pagination-text">
                  <Text t="itemToDisplay" />
                </span>

                <Dropdown overlay={menuDropdown} trigger={['click']}>
                  <span className="compliment-inputbox">
                    {showCount}
                    <CustomImage style={{ marginLeft: 10 }} src={iconChevronDown} />
                  </span>
                </Dropdown>
              </div>

              <CustomPagination
                current={currentPage}
                defaultCurrent={1}
                pageSize={showCount}
                total={ExcelTableList?.length}
                onChange={async (pageNumber, pageSize) => {
                  await handlePaginationChange(pageNumber, pageSize);
                }}
              />

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  position: 'absolute',
                  right: 20,
                  top: 35,
                  alignItems: 'center',
                }}
              >
                {currentLoadBalance?.periodType === 1 && (
                  <Tooltip
                    placement="topRight"
                    overlayClassName="custom-tooltip-excel-upload"
                    title={
                      <Text t="ifYouSelectThisOptionYouCanDownload" />
                    }
                  >
                    <button
                      onClick={downloadLiveExcel}
                      className="footer-info-download-excel"
                      style={{
                        backgroundColor: 'transparent',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderWidth: 0,
                        display: 'flex',
                      }}
                    >
                      <CustomImage src={iconExcel} style={{ marginRight: 5 }} />
                      <span style={{ color: '#1e293b', textDecoration: 'underline' }}>
                        {' '}
                        <Text t="exportEditsToExcel" />
                      </span>
                    </button>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        )}

        {createPortal(
          <div
            className="footer-info-container-excel"
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
          >
            {ExcelTableList?.length > 0 && (
              <div className="footer-top" style={{ display: 'flex', alignItems: 'center' }}>
                <CustomImage src={iconTCard} style={{ marginRight: 5 }} />
                <Text t="total" />{' '}
                <b className="dark-bold-text" style={{ marginLeft: 3, marginRight: 3 }}>
                  {totalOrderCount}
                </b>{' '}
                <Text t="cardsAdded" />
              </div>
            )}
            <div className="total-amount-title" style={{ marginTop: 5 }}>
              <b className="dark2-bold-text"><Text t="totalBalanceToBeLoadedUpperCaseColon" /></b>
              <span className="dark-bold-text">{moneyFormat(totalPrice, true)}</span>
            </div>
          </div>,
          document.getElementById('custom-sticky-container') || document.createElement('div'),
        )}

        {renderDeleteModal()}
      </div>
    );
  }
  return (
    <CustomCollapseCard
      cardTitle={cardInformation2}
      className="card-list-information excel-upload-table"
    >
      <div className="filter-container user-list-filter-container">
        <Collapse
          className="filter-collapse-card"
          ghost
          expandIconPosition="right"
          defaultActiveKey={['1']}
        >
          <Panel
            collapsible="disabled"
            header={
              <div>
                <Text t="addFilter" />
              </div>
            }
            key="1"
            showArrow={false}
          >
            <div>
              <CustomForm
                name="filterForm"
                className="filter-form"
                initialValues={{
                  showOnlyPriced: false,
                }}
                onValuesChange={onValuesChange}
                autoComplete="off"
                layout={'horizontal'}
                form={form}
                id="loadBalanceFilterForm"
              >
                <div className="form-item">
                  <CustomFormItem name="name" className="name-form-item">
                    <CustomInput
                      id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-name-input"
                      placeholder={useText('name')}
                      height={36}
                    />
                  </CustomFormItem>
                  <CustomFormItem name="surname" className="surname-form-item">
                    <CustomInput
                      id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-surname-input"
                      placeholder={useText('surname')}
                      height={36}
                    />
                  </CustomFormItem>

                  <CustomFormItem name="cardNumber" className="card-number-form-item">
                    <CustomNumberInput
                      id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-cardNumber-numberInput"
                      autoComplete="off"
                      placeholder={useText('cardNumber2')}
                      height={36}
                    />
                  </CustomFormItem>

                  <CustomFormItem name="refNo" className="reference-code-form-item">
                    <CustomInput
                      id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-refNo-input"
                      autoComplete="off"
                      placeholder={useText('referenceCode2')}
                      width={200}
                      height={36}
                    />
                  </CustomFormItem>

                  <div className="form-footer">
                    <CustomFormItem
                      label={false}
                      name="showOnlyPriced"
                      className="footer-form-item"
                      valuePropName="checked"
                    >
                      <CustomCheckbox
                        id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-showOnlyPriced-checkbox"
                        className="only-amount-check"
                      >
                        <Text t="showThoseWithAmountEntered2" />
                      </CustomCheckbox>
                    </CustomFormItem>
                    <div className="action-buttons">
                      <CustomButton
                        id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-clear-btn"
                        className="clear-btn"
                        onClick={clearForm}
                      >
                        <Text t="clean" />
                      </CustomButton>
                      <CustomButton
                        id="ticketRestaurant-balanceUpload-balanceInformation-cardListInformation-search-btn"
                        disabled={!isBtnActive}
                        className="search-btn"
                        onClick={submitFilter}
                      >
                        <CustomImage className="icon-search" src={iconSearchWhite} />{' '}
                        <Text t="search" />
                      </CustomButton>
                    </div>
                  </div>
                </div>
                <div />
              </CustomForm>
            </div>
          </Panel>
        </Collapse>
      </div>
      {showDeleteButton && (
        <div className="delete-button-container">
          <span className={'selected-text'}>
            <b>{selectedRowKeys.length}</b> <Text t="recordsSelected" />
          </span>
          {renderDeleteButton()}
        </div>
      )}

      {ExcelTableList?.length > 0 && (
        <VirtualizedAndLazyScrollTable
          rowSelection={{
            preserveSelectedRowKeys: true,
            type: 'checkbox',
            selectedRowKeys,
            onChange: onGridSelectChange,
            onSelectAll: async (selected) => {
              await dispatch(setIsAllSelectedRowKeys(selected));
            },
          }}
          pagination={false}
          dataSource={ExcelTableList}
          getDataFunc={() => { }}
          columnsData={columns}
          rowKey={(record) => `balance-upload-${record?.rowNumber}`}
        />
      )}

      {createPortal(
        <div className="footer-info-container-excel">
          {ExcelTableList?.length > 0 && (
            <div className="footer-top">
              <Text t="total" />
              <b className="red-text">{totalOrderCount}</b> <Text t="orderTitle" />
            </div>
          )}
          <div className="total-amount-title">
            <b>Toplam Tutar : </b>
            <span>{moneyFormat(totalPrice, true)}</span>
          </div>
          {currentLoadBalance?.periodType === 1 && (
            <Tooltip
              placement="topRight"
              overlayClassName="custom-tooltip-excel-upload"
              title={
                <Text t="ifYouSelectThisOptionYouCanDownload" />
              }
            >
              <button
                onClick={downloadLiveExcel}
                className="footer-info-download-excel"
                style={{ backgroundColor: 'transparent', borderWidth: 0 }}
              >
                <CustomImage src={iconExcel} />
                {excelUploadErrorMessages?.length > 0 ? (
                  <u>
                    <Text t="downloadAndEditExcel" />
                  </u>
                ) : (
                  <u>
                    <Text t="downloadExcel" />
                  </u>
                )}
              </button>
            </Tooltip>
          )}
        </div>,
        document.getElementById('custom-sticky-container') || document.createElement('div'),
      )}

      {renderDeleteModal()}
    </CustomCollapseCard>
  );
};

ExcelUploadTable.propTypes = {
  decodedExcelFile: PropTypes.any,
  excelParams: PropTypes.any,
  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
};
export default ExcelUploadTable;
